<template>
    <div class="assetssment__cover__box assesment__transcribe__wrapper tab-content tbh__popup__block transcribe__popup__wrap"
        id="tbh__popup__block1966">
        <!-- Header Section -->
        <div class="transcribe__head__wrap">
            <div class="title__group">
                <h4 class="title">Transcribe</h4>
            </div>
            <div class="popup__close__btn">
                <a href="javascript:void(0)" class="triggerTranscribeClose" @click="closeModal">
                    <img :src="closeIcon" />
                </a>
            </div>
        </div>

        <div class="divider__sepline"></div>

        <!-- Features Section -->
        <div class="transcribe__features__group">
            <div class="add__note__test__box response__group__wrapper">
                <div class="cover__group__box">
                    <div class="rlms-flex rlms-items-center rlms-gap-10">
                        <h6 class="title">Test Item</h6>
                        <Tooltip :content="`<div class='info__options__box' style='visibility: visible;opacity:1;'>
                                    <div class='options__group light__purple'>
                                        <div class='info__colors'></div><span class='options__text'>Default</span>
                                    </div>
                                    <div class='options__group light__green'>
                                        <div class='info__colors'></div><span class='options__text'>Correct</span>
                                    </div>
                                    <div class='options__group light__red'>
                                        <div class='info__colors'></div><span class='options__text'>Incorrect</span>
                                    </div>
                                </div>`" placement="right" width="auto">
                            <template #button>
                                <img :src="optionsInfoIcon" />
                            </template>
                        </Tooltip>
                    </div>
                    <div class="addnote__box">
                        <label style="display: flex; align-items: center; gap: 10px;">
                            {{ item.question }}
                            <Tooltip
                                :content="`${transcriptionMessage}`"
                                placement="right" v-if="item?.transcription_status">
                                <template #button>
                                    <img :src="optionsInfoIcon2" width="20" />
                                </template>
                            </Tooltip>

                        </label>
                        <template v-if="consonantStates?.length && item.consonant">
                            <div class="tbh__labels__group">
                                <template v-for="(c, index) in consonantStates" :key="index">
                                    <template v-if="c.value === '-'"> - </template>
                                    <template v-else-if="c.value === ' '"> &nbsp; </template>
                                    <template v-else>
                                        <span class="label"
                                            :class="[getClassForState(c.state), { 'disabled-label': noResponse }]"
                                            @click="() => ['pending', 'processing'].includes(item?.transcription_status) || noResponse ? null : toggleConsonant(index)"
                                            :title="noResponse ? 'Disabled when No Response is checked' : ''">
                                            {{ c.value }}
                                        </span>
                                    </template>
                                </template>
                            </div>
                        </template>
                        <template v-else>
                            <div class="tbh__labels__group checkbox__group">
                                <template v-for="(c, index) in consonantStates" :key="index">
                                    <div class="single__checkbox" :class="c">
                                        <input type="checkbox"
                                            @click="() => ['pending', 'processing'].includes(item?.transcription_status) || noResponse ? null : toggleConsonant(index)"
                                            :disabled="noResponse" :checked="c.state == 'green'" />
                                        <label></label>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <p class="note-text rlms-fs-xxs rlms-text-secondary-base rlms-mt-2" v-if="consonantStates?.length">
                            {{ item.consonant ? PHONEME_COLOUR_LEGEND : SYLLABLE_COUNT_LEGEND }}
                        </p>
                    </div>
                </div>

                <!-- No Response Option -->
                <div class="response__btn">
                    <div class="response_option">
                        <input type="checkbox" v-model="noResponse" id="response-input" class="rlms-checkbox"
                            :disabled="['pending', 'processing'].includes(item?.transcription_status)" />
                        <label for="response-input" style="padding-left: 10px;">No Response</label>
                    </div>
                </div>
            </div>

            <!-- Audio Player Section -->
            <div class="play__audio__feature">
                <h6 class="play__title">Play Audio</h6>
                <div class="play__control__options no__audio__label rlms-flex-col" v-if="!audioUrl">
                    <div class="play__audio__wave">
                        <span>{{ unavailableDetail ? RECORDING_UNAVAILABLE_TITLE : 'No Audio' }}</span>
                    </div>
                    <p class="recording-unavailable-note" v-if="unavailableDetail">{{ unavailableDetail }}</p>
                </div>
                <div class="play__control__options no__audio__label" v-show="audioUrl">
                    <div class="play__btn" v-if="audioUrl">
                        <img v-if="!isPlaying" class="imgPlay" :src="noPlayIcon" @click="togglePlayback" />
                        <img v-else class="imgPause" :src="pauseIcon" @click="togglePlayback" />
                    </div>
                    <div ref="waveformContainer" class="transcribeWaveform" v-show="audioUrl" style="width: 100%"></div>
                    <div class="play__audio__time" v-if="audioUrl">
                        <span class="time">{{ formattedTime }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Incorrect Details Section -->
        <div class="select__incorrect__details__box" v-show="!noResponse && redConsonants?.length > 0">
            <div class="select__title__group__box">
                <h6 class="title">Select Incorrect Details for a {{ item.question }}:</h6>
                <div class="title__result__box">
                    <div class="result__label__groups">
                        <template v-for="(c) in consonantStates" :key="c.id">
                            <span class="label__text transcribe__response__group__selection" v-show="c.state === 'red'"
                                :class="{ red__label: selectedConsonantIndex === c.id }"
                                @click="selectedConsonantIndex = c.id">
                                {{ c.value }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="divider__sepline"></div>

            <!-- Incorrect Reason Options -->
            <template v-for="(c) in consonantStates" :key="c.id">
                <div class="options__list__group__box transcribe__response__group__options"
                    v-show="c.state === 'red' && selectedConsonantIndex === c.id">
                    <div class="options__group">
                        <div class="options__item__box" v-for="option in ['omitted', 'repeated', 'wrong', 'other']"
                            :key="option">
                            <input type="radio" :id="`check__label${c.id}${option}`" :value="option"
                                v-model="incorrectReasons[c.id]" />
                            <label :for="`check__label${c.id}${option}`">{{ option.charAt(0).toUpperCase() +
                                option.slice(1) }}</label>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <!-- Tabs for Phonetic & Notes -->
        <div class="transcribe__tab__section">
            <div class="tab__btn__groups">
                <button
                    :class="['tab__btn', activePhoneticTab === 'phonetic' ? 'active__btn' : '', 'transcribe__tab__btn']"
                    @click="activePhoneticTab = 'phonetic'">
                    Phonetic Transcription
                </button>
                <button :class="['tab__btn', activePhoneticTab === 'note' ? 'active__btn' : '', 'transcribe__tab__btn']"
                    @click="activePhoneticTab = 'note'">
                    Note
                </button>
            </div>
        </div>

        <!-- Keyboard Area -->
        <div class="phonetic__keyboard__box">
            <div class="keyboard__group__box">
                <div v-show="activePhoneticTab === 'phonetic'"
                    class="keyboard__box__wrapper phonetic_tab_content tab_content_common">
                    <div class="keyboard__title__wrap">
                        <div class="checkbox__group">
                            <label>Phonetic Transcription</label>
                        </div>
                        <span class="question__icon">
                            <img :src="questionIcon" />
                        </span>
                    </div>

                    <!-- Phonetic Tags -->
                    <div class="keyboard__input__field">
                        <div class="bootstrap-tagsinput">
                            <template v-for="(tag, index) in phoneticTags" :key="index">
                                <span v-if="tag" class="tag label label-info" @click="removePhoneticTag(index)">{{ tag
                                }}</span>
                            </template>
                        </div>
                        <div class="search__info__btn">
                            <a href="javascript:void(0)" @click="showGuideSymbol = true">
                                <span class="btn__text">Info</span>
                                <span class="btn__icon">
                                    <img :src="btnInfoIcon">
                                </span>
                            </a>
                        </div>
                    </div>

                    <!-- Keyboard Buttons -->
                    <div class="keyboard__pad__box">
                        <div class="key__indicator__box">
                            <div v-for="(indicator, index) in indicators" :key="index" class="indicator__box"
                                :class="indicator.color">
                                <i class="indicator__icon"></i>
                                <span>{{ indicator.label }}</span>
                            </div>
                        </div>
                        <div class="keyboard__cover">
                            <button v-for="(key, index) in phoneticKeys" :key="index" type="button"
                                :class="['keyboard__key', key.color]" @click="addPhoneticTag(key.label)">{{ key.label
                                }}</button>
                            <button type="button" class="keyboard__backspace"
                                @click="handleBackspace">Backspace</button>
                        </div>
                    </div>
                </div>

                <!-- Notes Tab -->
                <div v-show="activePhoneticTab === 'note'"
                    class="keyboard__notes__box note_tab_content tab_content_common">
                    <label>Notes</label>
                    <textarea placeholder="Type Here" v-model.trim="notes" :readonly="!canConductAssessment"></textarea>
                </div>
            </div>
        </div>

        <!-- Footer Buttons -->
        <div class="popup__btn__box">
            <div class="purple__trans__btn button-hover">
                <a href="javascript:void(0)" @click="goToPrev">Prev</a>
            </div>
            <div class="purple__solid__btn">
                <a href="javascript:void(0)" @click="saveTranscribe">Save & Next</a>
            </div>
        </div>
    </div>
    <PhoneticSymbolModal v-if="showGuideSymbol" @close="showGuideSymbol = false" />
</template>
<script setup>
import api from '@/services/axios';
import { useLoaderStore } from '@/stores/loader';
import { indicators, phoneticKeys } from '@/utils/assessmentGroups';
import { showDialog, showToast } from '@/utils/swal';
import { computed, nextTick, onBeforeUnmount, ref, watch } from 'vue';
import WaveSurfer from 'wavesurfer.js';
import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions';
import PhoneticSymbolModal from './PhoneticSymbolModal.vue';
import { handleError } from '@/utils/handleError';
import closeIcon from '@/assets/images/close.svg';
import optionsInfoIcon from '@/assets/images/options-info-icon.png';
import optionsInfoIcon2 from '@/assets/images/danger.png';
import noPlayIcon from '@/assets/images/audio/transcribe/no-play.png';
import pauseIcon from '@/assets/images/audio/transcribe/pause.png';
import questionIcon from '@/assets/images/question-icon.png';
import btnInfoIcon from '@/assets/images/btn-info-icon.png';
import { authrizedPermissions } from '@/utils/permissions';
import { useAuthStore } from '@/stores/auth';
import Tooltip from '../Tooltip.vue';
import { PHONEME_COLOUR_LEGEND, SYLLABLE_COUNT_LEGEND } from '@/utils/assessment-notes';
import { RECORDING_UNAVAILABLE_TITLE, recordingUnavailableDetail } from '@/utils/recording-retention';

// Props from parent component
const props = defineProps({
    assessment: Object,
    item: Object,
    assessmentId: Number,
    organizationId: Number,
    canConductAssessment: Boolean,
});

// Emitters
const emit = defineEmits(['close', 'saved', 'navigate']);

// Reactive references
const waveformContainer = ref(null);
const wavesurfer = ref(null);
const audioUrl = ref('');
const isPlaying = ref(false);
const timeElapsed = ref(0);
const regions = RegionsPlugin.create();
const audioStartTime = ref(null);
const audioEndTime = ref(null);
const selectedConsonantIndex = ref(0);
const consonantScore = ref([]);
const consonantStates = ref([]);
const activePhoneticTab = ref('phonetic');
const phoneticTags = ref([]);
const incorrectReasons = ref([]);
const noResponse = ref(false);
const notes = ref('');
const showGuideSymbol = ref(false);
const loader = useLoaderStore();

// Format audio time display
const formattedTime = computed(() => {
    const min = Math.floor(timeElapsed.value / 60);
    const sec = timeElapsed.value % 60;
    return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
});

// Set only when this item's audio file has gone. The transcript, the marks and
// the score are untouched, so only the player changes.
const unavailableDetail = computed(() => recordingUnavailableDetail(props.item));

// Computed red consonants
const redConsonants = computed(() => consonantStates.value.filter(c => c.state === 'red'));

// Check if any consonant state is default. Only groups 1-3 show the sounds as
// coloured labels, so only there can the clinician see what is still unmarked;
// groups 4 and 5 use tick boxes and save the untouched ones as "not marked".
const anyDefault = computed(
    () => !!props.item?.consonant && consonantStates.value.some(c => c.state === 'default')
);

// Close modal handler
const closeModal = () => {
    emit('close');
};

// next modal handler
const goToNext = () => {
    emit('navigate', { id: props.item.id, direction: 'next' });
};

// next modal handler
const goToPrev = () => {
    emit('navigate', { id: props.item.id, direction: 'prev' });
};

// Audio player initialization
const initWaveSurfer = () => {
    loader.show();

    if (wavesurfer.value) wavesurfer.value.destroy();

    wavesurfer.value = WaveSurfer.create({
        container: waveformContainer.value,
        barWidth: 3,
        barGap: 1,
        barRadius: 1,
        height: 75,
        normalize: true,
        backend: 'WebAudio',
        blobMimeType: 'audio/webm',
        progressColor: 'rgba(114,92,255,1)',
        waveColor: 'rgba(210,199,254,1)',
        cursorColor: "#4a74a5",
        plugins: [regions]
    });

    wavesurfer.value.load(audioUrl.value);

    wavesurfer.value.on('ready', () => {
        timeElapsed.value = Math.floor(wavesurfer.value.getDuration());

        loader.hide();
    });

    wavesurfer.value.on('finish', () => {
        isPlaying.value = false;
        timeElapsed.value = Math.floor(wavesurfer.value.getDuration());
    });

    wavesurfer.value.on('audioprocess', (currentTime) => {
        if (Math.ceil(currentTime) <= Math.ceil(wavesurfer.value.getDuration())) {
            timeElapsed.value = Math.floor(currentTime);
        } else {
            setTimeout(() => {
                wavesurfer.value.stop();
                isPlaying.value = false;
                timeElapsed.value = Math.floor(wavesurfer.value.getDuration());
            }, 500);
        }
    });
    
    wavesurfer.value.on('decode', () => {
        if (audioStartTime.value && audioEndTime.value) {
            regions.addRegion({
                start: audioStartTime.value,
                end: audioEndTime.value,
                color: 'rgba(114, 92, 255, 0.50)',
                drag: false,
                resize: false,
            });
        }

        let loop = false

        {
            let activeRegion = null
            regions.on('region-in', () => {
                // activeRegion = region
                isPlaying.value = true
            })
            regions.on('region-out', (region) => {
                if (activeRegion === region) {
                    if (loop) {
                        region.play()
                    } else {
                        activeRegion = null
                        isPlaying.value = false;
                    }                    
                }
            })
            regions.on('region-clicked', (region, e) => {
                e.stopPropagation() // prevent triggering a click on the waveform
                activeRegion = region
                region.play(true);
                region.setOptions({ color: 'rgba(114, 92, 255, 0.50)' })
            })

            // Reset the active region when the user clicks anywhere in the waveform
            wavesurfer.value.on('interaction', () => {
                activeRegion = null
            });
        }
    })
};

// Toggle audio playback
const togglePlayback = () => {
    if (!wavesurfer.value) return;
    isPlaying.value ? wavesurfer.value.pause() : wavesurfer.value.play();
    isPlaying.value = !isPlaying.value;
};

// Toggle consonant state
const toggleConsonant = (index) => {
    if(!props.assessment?.is_latest) {
        showDialog({ icon: 'warning', title: "Assessment Completed", html: "This assessment has been marked as completed and may no longer be changed." });
        return;
    }

    if (!props.canConductAssessment) {
        let message = `You don’t have permission perform this action.`;
        const learner = props.assessment?.learner;

        if (learner?.is_administrator) {
            message = `You don’t have permission to perform this assessment because it was created before you were granted administrator access.`;
        } else if (learner?.is_authorized_user) {
            if (learner?.permissions?.[authrizedPermissions.conduct_view_assessments]) {
                message = `You don’t have permission to perform this assessment because it was created before you were granted group access.`;
            } else if (!learner?.permissions?.[authrizedPermissions.conduct_view_assessments]) {
                message = `Assessment available to you through group access. You don’t have permission perform this action.`;
            }
        }

        showDialog({ icon: 'warning', html: message });
        return;
    }

    if (noResponse.value) return;

    const current = consonantStates.value[index].state;
    consonantStates.value[index].state =
        current === 'default' || current === 'red' ? 'green' : 'red';

    incorrectReasons.value[index] = null;
    selectedConsonantIndex.value = redConsonants.value?.[0]?.id ?? 0;
};

// Assign class based on consonant state
const getClassForState = (state) => {
    if (state === 'green') return 'green';
    if (state === 'red') return 'red';
    return 'purple';
};

// Add/remove phonetic tags
const addPhoneticTag = (label) => phoneticTags.value.push(label);
const removePhoneticTag = (index) => phoneticTags.value.splice(index, 1);
const handleBackspace = () => phoneticTags.value.pop();

// Handle saving transcription data
const saveTranscribe = async () => {
    if(!props.assessment?.is_latest) {
        showDialog({ icon: 'warning', title: "Assessment Completed", html: "This assessment has been marked as completed and may no longer be changed." });
        return;
    }
    
    if (!props.canConductAssessment) {
        let message = `You don’t have permission perform this action.`;
        const learner = props.assessment?.learner;

        if (learner?.is_administrator) {
            message = `You don’t have permission to perform this assessment because it was created before you were granted administrator access.`;
        } else if (learner?.is_authorized_user) {
            if (learner?.permissions?.[authrizedPermissions.conduct_view_assessments]) {
                message = `You don’t have permission to perform this assessment because it was created before you were granted group access.`;
            } else if (!learner?.permissions?.[authrizedPermissions.conduct_view_assessments]) {
                message = `Assessment available to you through group access. You don’t have permission perform this action.`;
            }
        }

        showDialog({ icon: 'warning', html: message });
        return;
    }

    if (anyDefault.value && !noResponse.value) {
        showDialog({ icon: 'warning', html: 'Please mark the phonetics' });
        return;
    }

    try {
        loader.show();

        consonantStates.value.forEach((item, index) => {
            consonantScore.value[index] = item.state === 'green' ? 1 : item.state === 'default' ? null : 0;
        });

        const { data } = await api.post(
            `/organizations/${props.organizationId}/assessments/${props.assessmentId}/attempt`,
            {
                attemptid: props.item.id,
                phonetics: phoneticTags.value,
                consonant_score: noResponse.value ? null : consonantScore.value,
                notes: notes.value,
                incorrect_details: noResponse.value ? null : incorrectReasons.value,
                no_response: noResponse.value ? 'Y' : 'N',
            }
        );

        showToast({
            icon: 'success',
            title: 'Successful',
            text: 'Transcribe details saved successfully',
        });

        emit('saved', data?.data);

        goToNext();
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};

const fetchAudioBlobUrl = async (url) => {
    if (!url) return null;

    try {
        loader.show();
        const token = useAuthStore().token;
        const response = await api.get(url, {
            responseType: "blob",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return URL.createObjectURL(response.data);
    } catch (error) {
        handleError(error);

        return null;
    } finally {
        loader.hide();
    }
};

// Watch item and initialize state
watch(() => props.item, async (newItem) => {    
    // Parse phonetic tags
    phoneticTags.value = Array.isArray(newItem?.phonetic)
        ? newItem.phonetic.map(p => p.trim())
        : (newItem?.phonetic || '').split(',').map(p => p.trim());

    // Parse consonants
    let parsedConsonants = [];
    try {
        if (newItem?.consonant) {
            parsedConsonants = JSON.parse(newItem?.consonant?.replace(/'/g, '"')) || [];
        } else {
            parsedConsonants = newItem?.question.split('-');
        }
    } catch {
        parsedConsonants = [];
    }

    // Parse scores and details
    let parsedIncorrectDetails = [];
    parsedIncorrectDetails = JSON.parse(newItem?.incorrect_details) || [];

    let parsedConsonantScore = [];
    parsedConsonantScore = typeof newItem?.consonant_score === 'string'
        ? JSON.parse(newItem.consonant_score)
        : newItem?.consonant_score || [];

    // Map to state
    consonantStates.value = parsedConsonants.map((value, index) => {
        // Every slot starts unscored, including groups 4 and 5 (which have no
        // consonant list): a slot is only red once a 0 has actually been recorded.
        let state = 'default';
        const score = parsedConsonantScore?.[index];

        if (value === '-' || value === ' ') state = 'green';
        else if (score == 1 || score === true) state = 'green';
        else if (score == 0 || score === false) state = 'red';
        return { id: index, value, state };
    });

    incorrectReasons.value = parsedConsonants.map((_, i) => parsedIncorrectDetails?.[i] ?? null);

    notes.value = newItem?.notes ?? '';
    noResponse.value = newItem?.no_response === 'Y';
    selectedConsonantIndex.value = consonantStates.value.find(c => c.state === 'red')?.id ?? 0;
        
    audioStartTime.value = newItem.start_time;
    audioEndTime.value = newItem.end_time;

    audioUrl.value = await fetchAudioBlobUrl(newItem.audio);
    if (audioUrl.value) {
        nextTick(() => {
            initWaveSurfer();
        });
    }

}, { immediate: true, deep: true });

onBeforeUnmount(() => {
    if (wavesurfer.value) wavesurfer.value.pause();
});

const transcriptionMessage = computed(() => {
    if (props.item?.transcribe_automated) {
        switch (props.item?.transcription_status) {
            case "processing":
            case "pending":
                return `<p class="rlms-text-primary-400" style="font-size:14px;line-height:18px;">
                  Your transcription is currently in progress. Please wait and check back later.
                </p>`;
            case "completed":
                return `<p class="rlms-text-primary-400" style="font-size:14px;line-height:18px;">
                  Automatically selected transcription from audio. It may be incorrect, please verify manually.
                </p>`;
            case "failed":
                return `<p class="rlms-text-danger-400" style="font-size:14px;line-height:18px;">
                  Automated Transcription failed. Please try again or contact support.
                </p>`;
            default:
                return "";
        }
    } else {
        return `<p class="rlms-text-primary-400" style="font-size:14px;line-height:18px;">
              You have manually overridden the transcription.
            </p>`;
    }
});
</script>

<style scoped>
.recording-unavailable-note {
    margin: 6px 0 0;
    font-size: 13px;
    line-height: 18px;
    color: #6B7280;
    text-align: center;
}
</style>
